import dynamic from 'next/dynamic'
import { BlockProps } from '../BlockProps'
import { IPromoteServiceBlockData } from './IPromoteServiceBlockData'

export const DynamicPromoteServiceBlock = dynamic<
  BlockProps<IPromoteServiceBlockData>
>(() => import('./PromoteServiceBlock').then((md) => md.PromoteServiceBlock))
